import { LuChevronRight, LuPlug, LuSlidersVertical, LuTable2 } from "react-icons/lu";
import "./CRMSettings.scss";

const settings = [
  {
    title: "Module & Schnittstellen",
    description: "Modul-Registry und Andockpunkte für Tools und externe APIs.",
    icon: LuPlug,
  },
  {
    title: "Modul-Matrix",
    description: "Gebucht · aktiv · eigenständig · verbindbar mit · Upgrade-Hinweis.",
    icon: LuTable2,
  },
  {
    title: "Custom-Fields",
    description: "Zusätzliche Datenfelder für Core-Entitäten definieren.",
    icon: LuSlidersVertical,
  },
];

function CRMSettings() {
  return (
    <section className="crm-settings">
      <header className="crm-settings__header">
        <h1 className="crm-settings__title">Einstellungen</h1>
        <p className="crm-settings__subtitle">Zentrale Konfiguration des Plattform-Cores.</p>
      </header>

      <div className="crm-settings__grid">
        {settings.map(({ title, description, icon: Icon }) => (
          <article key={title} className="crm-settings__card">
            <span className="crm-settings__icon-wrapper" aria-hidden="true">
              <Icon />
            </span>
            <div className="crm-settings__card-content">
              <div className="crm-settings__card-heading">
                <h2 className="crm-settings__card-title">{title}</h2>
                <LuChevronRight className="crm-settings__chevron" aria-hidden="true" />
              </div>
              <p className="crm-settings__description">{description}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default CRMSettings;
